/**
 * FacetWP
 */

const $ = window.jQuery;

// Components
import { parseQueryString } from 'js/components/utilities';
import * as loading from 'js/components/loading';

let fwpLoadCount = 0;

//loading.show();
$('html').addClass('facetwp-loaded');

// Disable FacetWP's default loading effect
$(() => {
  FWP.loading_handler = () => {};
});

// Event listener for FacetWP to begin loading
$(document).on('facetwp-refresh', () => {
  loading.show();

  // Add facet loading class
  $('.facetwp-facet').addClass('is-loading');
});

// Event listener for FacetWP to finish loading
$(document).on('facetwp-loaded', () => {
  $('html').addClass('facetwp-loaded');

  // Remove parentheses from checkbox counts
  $('.facetwp-counter').text((_, text) => {
    return text.replace(/\(|\)/g, '');
  });

  let scrollOffset = 0;

  if ($(window).width() > 768) {
    scrollOffset = 76;
  }
  if ($(window).width() > 992) {
    scrollOffset = 190;
  }

  if (fwpLoadCount > 0) {
    $('html, body').animate(
      {
        scrollTop: $('.facetwp-template').offset().top - scrollOffset,
      },
      500
    );
  }
  fwpLoadCount++;

  // Hide empty facets
  $.each(FWP.settings.num_choices, (key, val) => {
    var $parent = $('.facetwp-facet-' + key).closest('.facetwp-facet-group');
    0 === val ? $parent.hide() : $parent.show();
  });

  // Remove facet loading class
  $('.facetwp-facet').removeClass('is-loading');

  setTimeout(() => {
    let query = window.location.search.substring(1);
    let qs = parseQueryString(query);

    if (qs) {
      $('.facetwp-facet-group-reset').removeClass('hidden');
    } else {
      $('.facetwp-facet-group-reset').addClass('hidden');
    }

    loading.hide();
  });
});

$('html').on('click', '.facetwp-btn.f-reset', (event) => {
  setTimeout(() => {
    FWP.reset('products_search');
    FWP.refresh();
  });
});
